var map = {
	"./Homepage1.png": 59607,
	"./Homepage2.png": 52028,
	"./Homepage3.png": 87941,
	"./Initiate1.png": 76992,
	"./Initiate2.png": 55323,
	"./Initiate3.png": 40498,
	"./Initiate4.png": 45357,
	"./Initiate5.png": 91460,
	"./Upload1.png": 80270,
	"./Upload2.png": 99045,
	"./Upload3.png": 65180,
	"./ask_simon_icon.png": 64816,
	"./cloud_CN.png": 77949,
	"./cloud_EN.png": 42199,
	"./explorer.png": 4925,
	"./import_data_CN.png": 49358,
	"./import_data_EN.png": 2168,
	"./interpreter.png": 13804,
	"./my_analyses_CN.png": 75345,
	"./my_analyses_EN.png": 82163,
	"./next_CN.png": 10607,
	"./next_EN.png": 99157,
	"./plotter.png": 39740,
	"./simon_ai1.png": 56502,
	"./simon_ai2.png": 47181,
	"./simon_ai3.png": 4676,
	"./simon_ai4.png": 14619,
	"./submit_CN.png": 98042,
	"./submit_EN.png": 81596,
	"./tutorials.png": 3471,
	"./upload_file_CN.png": 83916,
	"./upload_file_EN.png": 16874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93703;